import { render, staticRenderFns } from "./user-management-profiles-overview.vue?vue&type=template&id=113dae0e&"
import script from "./user-management-profiles-overview.vue?vue&type=script&lang=js&"
export * from "./user-management-profiles-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports